<div class="auth-container">
  <div class="auth-sub-container">

    <img src="logo.png" alt="Wide & Heavy" class="logo" matTooltip="Wide & Heavy"/>

    <h1 class="title">Admin Panel</h1>

    <form [formGroup]="form" (ngSubmit)="login()">
      <mat-form-field appearance="outline" (change)="storeEmail()" class="auth-form-field">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email" placeholder="Enter your email" />
        @if (form.get('email')?.hasError('required')) {
        <mat-error>
          Email is required
        </mat-error>
        }
        @if (form.get('email')?.hasError('email')) {
        <mat-error>
          Invalid email address
        </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="auth-form-field">
        <mat-label>Password</mat-label>
        <input matInput formControlName="password" [type]="hide() ? 'password' : 'text'"
          placeholder="Enter your password" #passwordInput />
        <button mat-icon-button matSuffix (click)="hide.set(!hide())" [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide()" type="button" class="mr-7" matTooltip="{{ hide() ? 'Show' : 'Hide' }} password">
          <mat-icon>{{ hide() ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>
        @if (form.get('password')?.hasError('required')) {
        <mat-error>
          Password is required
        </mat-error>
        }
        @if (form.get('password')?.hasError('minlength')) {
        <mat-error>
          Password must be at least {{ passwordMinLength }} characters
        </mat-error>
        }
      </mat-form-field>

      <button mat-flat-button class="main-button-squared-full-width lightyellow mb-25" type="submit">
        @if(!loading()) {
        <span>Continue</span>
        } @else {
        <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
        }
      </button>

    </form>

  </div>
</div>